<div class="seperator"></div>
<div class="title" mat-dialog-title>Add Credentials</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your MediaMath Account Manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Username</mat-label>
                <input matInput placeholder="Enter MediaMath Username" formControlName="username" data-cy="mediamath-username-input">
                <mat-error
                    *ngIf="connectionForm.get('username').errors && (connectionForm.get('username').touched || connectionForm.get('username').dirty)">
                    Invalid Username</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Password</mat-label>
                <input type="password" matInput placeholder="Enter MediaMath Password" formControlName="password" data-cy="mediamath-password-input">
                <mat-error
                    *ngIf="connectionForm.get('password').errors && (connectionForm.get('password').touched || connectionForm.get('password').dirty)">
                    Invalid Password</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Client ID</mat-label>
                <input type="password" matInput placeholder="Enter MediaMath Client ID" formControlName="clientId" data-cy="mediamath-client-id-input">
                <mat-error
                    *ngIf="connectionForm.get('clientId').errors && (connectionForm.get('clientId').touched || connectionForm.get('clientId').dirty)">
                    Invalid Client ID</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Client Secret</mat-label>
                <input type="password" matInput placeholder="Enter MediaMath Client Secret" formControlName="clientSecret" data-cy="mediamath-client-secret-input">
                <mat-error
                    *ngIf="connectionForm.get('clientSecret').errors && (connectionForm.get('clientSecret').touched || connectionForm.get('clientSecret').dirty)">
                    Invalid Client Secret</mat-error>
                </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="mediamath-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>